import InternalAPI from "../../../../../../app/axios"

export default class AgentRegistrationRepository extends InternalAPI{
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v1/agent"
        this.endpointV2 = "/v2/agent"
    }

      /**
     *
     * @param param {string}
     * @return {Promise<{data: Array<Agent>, err: null}|{data: null, err: ErrorState}>}
     */
       async getAll(param) {

        try {
            /** @type {AxiosResponse<Array<Object>>} */
            const res = await this.$axios.get(this.endpointV2 + "/data?"+param);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }

    /**
     *
     * @param agentID {string}
     * @return {Promise<{data: Agent, err: null}|{data: null, err: ErrorState}>}
     */
     async getOne(agentID) {
        try {
            /** @type {AxiosResponse<Object>} */
            const res = await this.$axios.get(this.endpointV2 + "/" + agentID);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }

     /**
     *
     * @param formData {FormData}
     * @param agentID {string}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
      async updateOne(formData, agentID) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.put(this.endpointV2+"/"+agentID, formData)
            if (res.status === 200) {
                return {err: null}
            }
            return {err: "something went wrong"}
        } catch (err) {
            return {err: this.setErrorMessage(err.response.data)}
        }
    }
}